/**
 * A link somebody typed, made safe to put in an `href`.
 *
 * Members typed their websites into a form and most left the scheme off, so
 * about 150 legacies are stored as `houthuesen.org`. A bare domain in an
 * `href` is a *relative* path: the browser resolves it against the current
 * page and sends the reader to `/organizations/houthuesen.org` on our own
 * site, which 404s. It looks like a broken link on the estate's page and
 * reads as our fault.
 *
 * `javascript:` and `data:` are refused outright. These strings come from
 * member input and go straight into an anchor, which is the one place a
 * scheme can execute.
 */
export function externalUrl(value: string | null | undefined): string | null {
  const raw = (value ?? "").trim();
  if (!raw) return null;
  if (/^[a-z][a-z0-9+.-]*:/i.test(raw)) {
    return /^https?:\/\//i.test(raw) ? raw : null;
  }
  // No scheme at all: it has to look like a domain before we invent one.
  if (!/^[a-z0-9-]+(\.[a-z0-9-]+)+([/?#]|$)/i.test(raw)) return null;
  return `https://${raw}`;
}

/** What to show for it: the address without the scheme we may have added. */
export function externalUrlLabel(value: string | null | undefined): string {
  return (value ?? "").trim().replace(/^https?:\/\//i, "");
}
